<template>
    <div class="flex min-h-screen w-full flex-col justify-between pt-16 lg:pt-24">
        <div class="container mx-auto flex w-full max-w-full grow flex-col justify-center sm:w-2/3 md:w-2/3 lg:w-5/12 [&>:first-child]:flex [&>:first-child]:w-full [&>:first-child]:grow">
            <slot />
        </div>
    </div>
</template>
